import React from "react";

export default function tradeIcon({ fill }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.36816 4.82853C7.36816 4.04113 7.36816 3.64743 7.61278 3.40282C7.85739 3.1582 8.25109 3.1582 9.03849 3.1582H10.961C11.7484 3.1582 12.1421 3.1582 12.3867 3.40282C12.6313 3.64743 12.6313 4.04113 12.6313 4.82853V15.1721C12.6313 15.9595 12.6313 16.3532 12.3867 16.5978C12.1421 16.8424 11.7484 16.8424 10.961 16.8424H9.03849C8.25109 16.8424 7.85739 16.8424 7.61278 16.5978C7.36816 16.3532 7.36816 15.9595 7.36816 15.1721V4.82853Z"
        fill={fill}
      />
      <path
        d="M0 10.6703C0 9.88293 0 9.48923 0.244613 9.24461C0.489227 9 0.882926 9 1.67032 9H3.59283C4.38023 9 4.77393 9 5.01854 9.24461C5.26316 9.48923 5.26316 9.88293 5.26316 10.6703V15.7507C5.26316 16.5381 5.26316 16.9318 5.01854 17.1764C4.77393 17.4211 4.38023 17.4211 3.59283 17.4211H1.67033C0.882926 17.4211 0.489227 17.4211 0.244613 17.1764C0 16.9318 0 16.5381 0 15.7507V10.6703Z"
        fill={fill}
      />
      <path
        d="M14.9819 4.56053C14.7373 4.80514 14.7373 5.19884 14.7373 5.98624V11.0666C14.7373 11.854 14.7373 12.2477 14.9819 12.4924C15.2265 12.737 15.6202 12.737 16.4076 12.737H18.3301C19.1175 12.737 19.5112 12.737 19.7558 12.4924C20.0005 12.2477 20.0005 11.854 20.0005 11.0666V5.98624C20.0005 5.19884 20.0005 4.80514 19.7558 4.56053C19.5112 4.31592 19.1175 4.31592 18.3301 4.31592H16.4076C15.6202 4.31592 15.2265 4.31592 14.9819 4.56053Z"
        fill={fill}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.63189 19.8419C2.34121 19.8419 2.10557 19.6063 2.10557 19.3156L2.10557 6.68403C2.10557 6.39335 2.34121 6.15771 2.63189 6.15771C2.92256 6.15771 3.1582 6.39335 3.1582 6.68403L3.1582 19.3156C3.1582 19.6063 2.92256 19.8419 2.63189 19.8419Z"
        fill={fill}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.0001 20C9.70938 20 9.47374 19.7644 9.47374 19.4737L9.47374 0.526316C9.47374 0.23564 9.70938 1.20371e-08 10.0001 0C10.2907 -1.20371e-08 10.5264 0.23564 10.5264 0.526316L10.5264 19.4737C10.5264 19.7644 10.2907 20 10.0001 20Z"
        fill={fill}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.3682 15.8946C17.0775 15.8946 16.8419 15.6589 16.8419 15.3682V1.68403C16.8419 1.39335 17.0775 1.15771 17.3682 1.15771C17.6589 1.15771 17.8945 1.39335 17.8945 1.68403V15.3682C17.8945 15.6589 17.6589 15.8946 17.3682 15.8946Z"
        fill={fill}
      />
    </svg>
  );
}
